window.BUILDER = window.BUILDER || {};
window.BUILDER.modalContent = {
  accessories: {
    "Pipe Framing Kit": {
      title: "Pipe Framing Kit",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/golf_pdp_golf_accessories_diy_pipe_frame_kit_hero_image.jpg?v=1745190961"
      ],
      html: `
        <h3>Add the Pipe Framing Kit – No Hardware Store Run Needed</h3>
        <p>Make setup easy with our pre-cut <strong>Pipe Framing Kit</strong>. It includes everything you need to build your golf enclosure frame, cut to the exact lengths for a seamless install.</p>
        <p>Prefer to handle it yourself? No problem. You can skip this add-on and source your own <strong>1&quot; EMT conduit</strong> locally — we’ll still include a detailed cut list so you know exactly what to get.</p>
      `
    },

    "Pipe Framing Kit - Custom": {
      title: "Pipe Framing Kit - Custom",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-top.jpg?v=1745190960",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-top-right.jpg?v=1745190961",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-top-left.jpg?v=1745190960",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-close.jpg?v=1745190961",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-side-angle.jpg?v=1745190960",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-side.jpg?v=1745190960"
      ],
      html: `
        <h3>Add the Pipe Framing Kit – No Hardware Store Run Needed</h3>
        <p>Make setup easy with our pre-cut <strong>Pipe Framing Kit</strong>. It includes everything you need to build your golf enclosure frame, cut to the exact lengths for a seamless install.</p>
        <p>Prefer to handle it yourself? No problem. You can skip this add-on and source your own <strong>1&quot; EMT conduit</strong> locally — we’ll still include a detailed cut list so you know exactly what to get.</p>
      `
    },

    "Foam Insert Kit": {
      title: "Foam Insert Kit",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/foam-enclosure-kit.jpg?v=1745191485",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/foam-dimensions.jpg?v=1745191486",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/installing-diy-foam.jpg?v=1745191485",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/securing-diy-foam.jpg?v=1745191485"
      ],
      html: `
        <h3>Foam Insert Kit – Added Safety & Protection</h3>
        <p>Highly recommended to close the gap between your impact screen and enclosure frame for added protection and peace of mind.</p>
        <ul class="list-disc list-inside">
          <li>High-density memory foam cushions</li>
          <li>Custom cut to fit your enclosure perfectly</li>
          <li>Slides behind screen flaps for a cleaner look and safer setup</li>
          <li>Slows down ricochets from golf balls that contact the frame</li>
          <li>Enhances protection for your enclosure frame</li>
        </ul>
        <p>Our golf enclosures are designed with flaps that stretch tightly from screen to wall, shielding the frame from direct impact. The <strong>Foam Insert Kit</strong> takes that protection even further by filling the gap between the screen and frame—creating a safer, more professional enclosure setup.</p>
      `
    },

    "Safety Baffle": {
      title: "Safety Baffle",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/diy-enclosure-baffles.jpg?v=1745194822"
      ],
      html: `
        <h3>Safety Baffle – Catch High Shots Before They Rebound</h3>
        <p>Designed for added peace of mind, our <strong>Safety Baffle</strong> helps catch high-angle shots before they can rebound off the screen.</p>
        <ul class="list-disc list-inside">
          <li>Durable vinyl strips hang from the ceiling</li>
          <li>Helps knock down wedge shots or high launches</li>
          <li>Place one or multiple baffles at varying distances from the screen</li>
          <li>Minimizes risk of bounce-back in tighter setups</li>
        </ul>
        <p>Perfect for players who take aggressive lofted shots or want an extra layer of protection—especially in low-ceiling or close-quarters environments.</p>
      `
    },

    "Net Wall Extensions (Pair)": {
      title: "Net Wall Extensions (Pair)",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/nwe-1.jpg?v=1745195183",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/nwe-2_1.jpg?v=1745195182",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/nwe-3_1.jpg?v=1745195183"
      ],
      html: `
        <h3>Net Wall Extensions – Extra Side Protection</h3>
        <p>Add peace of mind to your setup with our <strong>Net Wall Extensions</strong>. This set of two 8' net panels adds side protection to keep stray shots contained.</p>
        <ul class="list-disc list-inside">
          <li>Includes two 8' net walls for added enclosure depth</li>
          <li>Creates an extra barrier for errant golf balls</li>
          <li>Easily attaches to your enclosure frame with hook-and-loop fasteners</li>
          <li>Weighted sandbag bottom keeps nets secure</li>
        </ul>
        <p>Ideal for tighter rooms or players working on swing consistency—these nets help keep balls in the hitting zone and protect your space.</p>
      `
    },

    "Back Cover Kit": {
      title: "Back Cover Kit",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/diy-back-cover-kit.jpg?v=1745195353"
      ],
      html: `
        <h3>Back Cover Kit – Light Control & Added Safety</h3>
        <p>Our <strong>Back Cover Kit</strong> is designed to fully wrap the rear of your enclosure, creating a more immersive simulator space while helping block out ambient light and stray golf balls.</p>
        <ul class="list-disc list-inside">
          <li>Wraparound cover with included fittings (pipe kit sold separately)</li>
          <li>Attaches easily with hook-and-loop fasteners</li>
          <li>Reduces light bleed for a darker, theater-like environment</li>
          <li>Helps stop low-rolling balls from sneaking under the screen</li>
          <li>Highly recommended for high-pile turf setups</li>
        </ul>
        <p>Whether you’re perfecting your swing or grinding out a round, the Back Cover Kit helps keep your space focused, safe, and distraction-free.</p>
      `
    },

    "Back Cover Pipe Kit": {
      title: "Back Cover Pipe Kit",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/custom-gek-pipe-kit-close.jpg?v=1745190961"
      ],
      html: `
        <h3>Back Cover Pipe Kit – Skip the Hardware Store</h3>
        <p><strong>Only recommended if you're adding the Back Cover Kit</strong> – this optional <strong>Pipe Kit</strong> includes all the pre-cut pipes needed to support the wraparound cover on your enclosure.</p>
        <ul class="list-disc list-inside">
          <li>Pre-cut pipes tailored to your enclosure size</li>
          <li>No cutting, hauling, or guesswork required</li>
          <li>Saves time and effort during setup</li>
        </ul>
        <p>As with our enclosure frames, you’re welcome to source 1&quot; EMT conduit locally if you prefer. Either way, we make it easy.</p>
      `
    }
  },

  launchMonitor: {
    "Garmin Approach R50": {
      title: "Garmin Approach R50",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Golf-Sim-Depot-Front.webp?v=1742432461",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Golf-Sim-Depot-Angle-2.webp?v=1742432461",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Golf-Sim-Depot-Angle.webp?v=1742432461",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Golf-Sim-Depot-Top.webp?v=1743369313",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Page-Golf-Simulator-2-Golf-Sim-Depot.png?v=1742429502",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Garmin-R50-Page-Simulator-Golf-Sim-Depot.png?v=1742428780"
      ],
      html: `
        <h3>Garmin Approach R50 – Big Screen, Bigger Data</h3>
        <p>The <strong>Garmin R50</strong> combines radar accuracy with high-speed cameras and a built-in 10” touchscreen for an all-in-one golf simulator experience. Play over 43,000 courses with Home Tee Hero and visualize your swing like never before.</p>
        <ul class="list-disc list-inside">
          <li>10” color touchscreen with high-speed impact video</li>
          <li>Use indoors or outdoors with up to 15+ tracked metrics</li>
          <li>3 high-speed cameras for advanced visual feedback</li>
          <li>Includes carry case, AC power adapter, and club tracking stickers</li>
          <li>Pairs with Garmin Golf app for course play and practice sessions</li>
        </ul>
        <p>Position approximately 1.5 feet beside the tee area for optimal tracking. Enjoy up to 4 hours of battery life and seamless integration with Garmin’s software ecosystem.</p>
      `
    },

    "ProTee VX": {
      title: "ProTee VX",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ProTee-VX-Launch-Monitor-ProTee-United-21112558.webp?v=1733962868",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ProTee-VX-Launch-Monitor-ProTee-United-21112613.webp?v=1733962862",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ProTee-VX-Launch-Monitor-ProTee-United-21112754.webp?v=1733962858",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ProTee-VX-Launch-Monitor-ProTee-United-21112972.jpg?v=1733962873"
      ],
      html: `
        <h3>ProTee VX – AI-Powered Accuracy at a Great Price</h3>
        <p>The <strong>ProTee VX</strong> uses dual high-speed cameras and advanced A.I. to measure an impressive range of ball and club data—all with no special balls or club stickers. Its overhead mount keeps the hitting area clean and works for both right and left-handed golfers without recalibration.</p>
        <ul class="list-disc list-inside">
          <li>Tracks over 25 metrics including spin, impact location, and dynamic loft</li>
          <li>Instant response time with machine-learning powered tracking</li>
          <li>Simple ceiling mount with included hardware and calibration board</li>
          <li>Supports both basic setups and advanced simulator environments</li>
          <li>All ProTee VX sales are final – please review specs carefully</li>
        </ul>
        <p>Requires mounting height of 9–10 ft and a position 3–4 ft in front of the tee. Runs on Windows 10/11 and is compatible with most simulator software platforms.</p>
      `
    },

    "SkyTrak+": {
      title: "SkyTrak+",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SkyTrak_-Portable-Launch-Monitor-_-Golf-Simulator-SkyTrak-21046865.webp?v=1733960853",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SkyTrak_-Portable-Launch-Monitor-_-Golf-Simulator-SkyTrak-21047024.webp?v=1733960866",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SkyTrak_-Portable-Launch-Monitor-_-Golf-Simulator-SkyTrak-21047526.webp?v=1733960861",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SkyTrak_-Portable-Launch-Monitor-_-Golf-Simulator-SkyTrak-21047488.webp?v=1733960863",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SkyTrak_-Portable-Launch-Monitor-_-Golf-Simulator-SkyTrak-21047354.webp?v=1733960857"
      ],
      html: `
        <h3>SkyTrak+ – Tour-Level Accuracy Without the Price Tag</h3>
        <p>The <strong>SkyTrak+</strong> builds on the legacy of the original SkyTrak with enhanced accuracy, machine learning, and upgraded club tracking. It’s a favorite for golfers who want data-driven improvement without breaking the bank.</p>
        <ul class="list-disc list-inside">
          <li>Tracks ball speed, club speed, club path, face angle, and smash factor</li>
          <li>Use it with the SkyTrak app or upgrade to unlock course play features</li>
          <li>Includes USB cable, iOS/Android app, and practice range software</li>
          <li>Works with most popular simulator platforms via upgrade</li>
          <li>No specific space requirements – great for tight setups</li>
        </ul>
        <p>SkyTrak+ includes basic range software. To unlock full simulator play, you’ll need to upgrade to a Game Improvement or higher subscription. A solid choice for beginners and seasoned players alike.</p>
      `
    },

    "Rapsodo MLM2Pro": {
      title: "Rapsodo MLM2Pro",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/MLM2PROwCallawayChromeTourGolfBalls1.jpg?v=1745151585",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/MLM2PROwTitleistPROV1GolfBalls1_1.png?v=1745151562",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Rapsodo-MLM2PRO_-Mobile-Launch-Monitor-_-Golf-Simulator-Rapsodo-20992695_c78ac8d3-04f2-41ae-99b2-89a386b85c06.webp?v=1743963626",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/MLM2PRO_3Cameras.png?v=1745151562",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/MLM2PRO_IndoorOutdoor.png?v=1745151562",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Rapsodo-MLM2PRO_-Net-Return-Package-Premium-Golf-Sim-Depot-21102647.jpg?v=1733962549"
      ],
      html: `
        <h3>Rapsodo MLM2PRO – Portable Power with Pro-Level Data</h3>
        <p>The <strong>MLM2PRO</strong> combines dual-camera vision and radar processing to deliver highly accurate swing and ball data, indoors or out. Capture spin, trajectory, and club performance—plus access 30,000+ simulated courses with premium third-party software like E6 Connect and Awesome Golf.</p>
        <ul class="list-disc list-inside">
          <li>Measures spin rate, spin axis, ball and club speed, smash factor, apex height, and more</li>
          <li>Quick Connect Wi-Fi pairing and intuitive cloud data tracking</li>
          <li>Shot Vision + Impact Vision replay your swings in detail</li>
          <li>Includes 3 Callaway® RPT™ balls to measure spin with 1% accuracy</li>
          <li>Compatible with Apple and Android devices</li>
        </ul>
        <p>Includes a tripod, carrying case, charger, and 1-year Premium Membership—featuring Rapsodo Combines, R-Cloud video storage, R-Speed swing tracking, and full access to simulation tools. Designed to sit 6.5–8.5 feet behind the ball.</p>
      `
    },

    "Uneekor EYE MINI LITE": {
      title: "Uneekor EYE MINI LITE",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-LITE-Launch-Monitor-Uneekor-21024619.webp?v=1733960205",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-LITE-Launch-Monitor-Uneekor-21024888.webp?v=1733960201",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-LITE-Launch-Monitor-Uneekor-21024799.webp?v=1733960198",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-LITE-Launch-Monitor-Uneekor-21024981.webp?v=1733960190",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-LITE-Launch-Monitor-Uneekor-21025131.webp?v=1733960194"
      ],
      html: `
        <h3>Uneekor EYE MINI LITE – Compact, Accurate, Indoor-Only</h3>
        <p>The <strong>EYE MINI LITE</strong> brings Uneekor’s trusted accuracy into a streamlined, PC-only package. This fixed unit is perfect for dedicated indoor simulator setups, delivering reliable ball and club data at an incredible value.</p>
        <ul class="list-disc list-inside">
          <li>Tracks ball speed, spin, launch angle, and carry distance using unmarked balls</li>
          <li>Club data includes path, speed, angle of attack, and smash factor (with stickers)</li>
          <li>Includes Uneekor VIEW software for PC and connection tools</li>
          <li>Compact, easy to integrate into existing enclosures</li>
        </ul>
        <p>Requires a gaming PC (Windows 10+), Ethernet port, and GeForce GTX 1060 GPU or better. Optional upgrades available for third-party software and Refine/Refine+ training modules.</p>
      `
    },

    "Uneekor EYE XO": {
      title: "Uneekor EYE XO",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO-Launch-Monitor-Uneekor-21039126.webp?v=1733960633",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO-Launch-Monitor-Uneekor-21039278.webp?v=1733960636",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO-Launch-Monitor-Uneekor-21039452.png?v=1733960643",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO-Launch-Monitor-Uneekor-21039545.webp?v=1733960645",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO-Launch-Monitor-Uneekor-21039366.webp?v=1733960639"
      ],
      html: `
        <h3>Uneekor EYE XO – Pro-Level Data with Overhead Simplicity</h3>
        <p>The <strong>EYE XO</strong> delivers elite-level accuracy with non-marked ball tracking and full-club data using reflective dots. Overhead-mounted for a clutter-free hitting area, it captures every detail of your swing and ball flight in stunning clarity.</p>
        <ul class="list-disc list-inside">
          <li>3000 FPS dual-camera system for ball and club tracking</li>
          <li>Use any ball – no markings required</li>
          <li>Tracks smash factor, dynamic loft, impact location, spin, and more</li>
          <li>Includes Uneekor VIEW software and club stickers (400 count)</li>
          <li>Requires 9–10 ft ceiling height and mounts 3.5 ft ahead of tee</li>
        </ul>
        <p>The EYE XO is compatible with Swing Optix, Ignite, Refine, and third-party software. Perfect for both high-performance practice and full-course simulation in home studios.</p>
      `
    },

    "Uneekor EYE XO2": {
      title: "Uneekor EYE XO2",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO2-Launch-Monitor-Uneekor-21106823.png?v=1733962682",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO2-Launch-Monitor-Uneekor-21106944.png?v=1733962685",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO2-Launch-Monitor-Uneekor-21107019.png?v=1733962688",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO2-Launch-Monitor-Uneekor-21107168.png?v=1733962691",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XO2-Launch-Monitor-Uneekor-21107210.png?v=1733962698"
      ],
      html: `
        <h3>Uneekor EYE XO2 – Expanded Hitting Zone, Unmatched Precision</h3>
        <p>The <strong>EYE XO2</strong> brings next-level flexibility to Uneekor’s elite overhead launch monitor lineup. Featuring three high-speed IR cameras and support for multiple hitting surfaces—including tee, fairway, rough, and bunker—the XO2 delivers full immersion and pro-level data capture.</p>
        <ul class="list-disc list-inside">
          <li>Three high-speed infrared cameras with massive 28&quot; x 21&quot; hitting zone</li>
          <li>Supports different hitting surfaces with ball flight adjustments for lie type</li>
          <li>Tracks full club data with stickers and unmarked ball metrics</li>
          <li>Includes Player Package with a 3-month trial of the Champion Package</li>
          <li>Comes with Uneekor’s Trouble Mat for simulating rough and bunker shots</li>
        </ul>
        <p>The EYE XO2 includes mounting hardware, Ethernet cabling, power kit, 400 club stickers, and more. Compatible with Swing Optix, Ignite, Refine, and third-party software. Perfect for dual-user setups and simulator studios that want the best.</p>
      `
    },

    "Uneekor EYE XR": {
      title: "Uneekor EYE XR",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-XR-Feature-3_1013x1013_ebddc5a1-0f20-4d5a-a305-ef68cc4a67c1.webp?v=1757214329",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/xr3-Golf-Sim-Depot.webp?v=1757214153",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/xr5-Golf-Sim-Depot.webp?v=1744713580",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/xr4-Golf-Sim-Depot.webp?v=1744713580"
      ],
      html: `
        <h3>Uneekor EYE XR – Advanced Overhead Accuracy</h3>
        <p>The <strong>EYE XR</strong> is Uneekor’s next-gen overhead launch monitor, blending quad-camera technology with a spacious hitting zone. Designed for serious golfers and studios, it captures more data points with unmatched precision for both left and right-handed players.</p>
        <ul class="list-disc list-inside">
          <li>Measures 28 ball and club data parameters for in-depth analysis</li>
          <li>Quad-camera system with infrared tracking for tour-level accuracy</li>
          <li>Oversized hitting zone – supports seamless right and left-handed play</li>
          <li>Instant feedback with Uneekor VIEW, Refine, and Refine+ software</li>
          <li>Compatible with third-party simulation platforms like GSPro, TGC 2019, and E6 Connect</li>
        </ul>
        <p>Includes EYE XR hardware, mounting bracket, calibration tools, power and Ethernet cables, and access to Uneekor’s powerful software ecosystem for practice and full simulation play.</p>
      `
    },

    "Uneekor EYE MINI": {
      title: "Uneekor EYE MINI",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-Portable-Launch-Monitor-Uneekor-21023885.webp?v=1733960166",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-Portable-Launch-Monitor-Uneekor-21023944.webp?v=1733960169",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-Portable-Launch-Monitor-Uneekor-21024180.webp?v=1733960175",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-EYE-MINI-Portable-Launch-Monitor-Uneekor-21024268.webp?v=1733960173"
      ],
      html: `
        <h3>Uneekor EYE MINI – Pro-Grade Performance, Anywhere</h3>
        <p>The <strong>EYE MINI</strong> combines Uneekor’s powerful data engine with true portability. Set it up at home, in the garage, or at the driving range. With support for PC and iPad, you can practice with precision anywhere.</p>
        <ul class="list-disc list-inside">
          <li>Tracks ball and club data with signature Uneekor accuracy</li>
          <li>Use unmarked balls for ball data, and club stickers for full swing analysis</li>
          <li>Compatible with Uneekor VIEW software for PC and iPad</li>
          <li>Ideal for both fixed setups and mobile use</li>
          <li>Connects via Ethernet or Wi-Fi and supports multiple training platforms</li>
        </ul>
        <p>Includes carrying case, calibration chart, club stickers, power and Ethernet cables. PC requirements include GTX 1060 GPU and Windows 10 or later. A high-value option for golfers on the go who want full data fidelity.</p>
      `
    },

    "Uneekor QED": {
      title: "Uneekor QED",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-QED-Launch-Monitor-Uneekor-21031189.webp?v=1733960389",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-QED-Launch-Monitor-Uneekor-21031232.webp?v=1733960392",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Uneekor-QED-Launch-Monitor-Uneekor-21031360.webp?v=1733960395"
      ],
      html: `
        <h3>Uneekor QED – Reliable, Overhead, and Fast</h3>
        <p>The <strong>QED</strong> is the launch monitor that introduced Uneekor’s powerful dual-camera tech. Still a strong contender, it provides fast, accurate data with ball and club replay powered by Ignite software.</p>
        <ul class="list-disc list-inside">
          <li>Dual high-speed cameras track spin, launch, club path, and more</li>
          <li>Includes Ball and Club OPTIX replay tools</li>
          <li>Mounts overhead, 3.5 ft behind the hitting area</li>
          <li>Supports practice modes, driving range, short game, and course play</li>
          <li>Includes 24 non-branded marked balls and full mounting kit</li>
        </ul>
        <p>The QED is perfect for dedicated sim rooms and is a great fit for golfers who want Uneekor quality at an accessible price point. Compatible with third-party software and upgradeable within the Uneekor ecosystem.</p>
      `
    },

    "Nvisage N1": {
      title: "Nvisage N1",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/NVISAGE_Side.webp?v=1714687871",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/NVISAGE_Front.webp?v=1714687913",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/NVISAGE_Right_Side.webp?v=1714687872"
      ],
      html: `
        <h3>NVISAGE N1 – Affordable Overhead Precision</h3>
        <p>The <strong>NVISAGE N1</strong> offers incredible ball-tracking accuracy at a budget-friendly price. With dual 2,000FPS cameras and support for third-party golf simulator software, it's a true plug-and-play solution for game improvement.</p>
        <ul class="list-disc list-inside">
          <li>Overhead-mounted with 24&quot; x 20&quot; hitting zone</li>
          <li>Tracks spin axis, launch angle, total spin, and more (using marked balls)</li>
          <li>Ideal for home simulator setups focused on ball data</li>
          <li>Includes calibration board, marked balls, and all mounting hardware</li>
          <li>Compatible with most PC-based sim software – just match system specs</li>
        </ul>
        <p>Mounts 9–10 ft above your hitting surface and 2 ft in front of your hitting zone. A great choice for value-focused golfers who want high-speed performance without sticker shock.</p>
      `
    },

    "Full Swing KIT": {
      title: "Full Swing KIT",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-front_1200x_f8dd0bf2-c30d-4e5d-a01b-2f1088b8bbdf.webp?v=1738109961",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-side_1200x_e3f0b123-db4b-4afe-b892-e2622a21a9e1.webp?v=1738111009",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-rear.webp?v=1738111009",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-range.webp?v=1738111009",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-Apple.webp?v=1738111009",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Full-Swing-KIT-Tiger.webp?v=1738111009"
      ],
      html: `
        <h3>Full Swing KIT – Radar-Based, Tour-Tested</h3>
        <p>The <strong>Full Swing KIT</strong> delivers tour-level data using cutting-edge radar and a built-in 1080p camera. Trusted by Tiger Woods, it's designed for players who want instant feedback without needing a secondary device to see results.</p>
        <ul class="list-disc list-inside">
          <li>Tracks 16 key data points, including face angle, spin axis, and side carry</li>
          <li>Customizable OLED display shows real-time metrics</li>
          <li>Built-in video recording with auto-sync to your iPhone or iPad</li>
          <li>5-hour battery life and Bluetooth audio support</li>
          <li>Optimized for both home simulators and outdoor range sessions</li>
        </ul>
        <p>Sits 10 feet behind the ball on the same level as your hitting area. For best accuracy, use with a minimum of 10 feet between tee and screen/net. Includes USB-C charger and connects easily via the Full Swing app.</p>
      `
    }
  },

  projector: {
    "BenQ TH671ST": {
      title: "BenQ TH671ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-TH671ST-Golf-Simulator-Projector-BenQ-20996372.webp?v=1733959375",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-TH671ST-Golf-Simulator-Projector-BenQ-20996269.webp?v=1733959378",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-TH671ST-Golf-Simulator-Projector-BenQ-20996494.webp?v=1742857895",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-TH671ST-Golf-Simulator-Projector-BenQ-20996516.webp?v=1733959385"
      ],
      html: `
        <h3>BenQ TH671ST – Affordable Entry-Level Clarity</h3>
        <p>The <strong>TH671ST</strong> offers full 1080p visuals, low input lag, and a short-throw design—making it one of the best budget projectors for golf simulators.</p>
        <ul class="list-disc list-inside">
          <li>Full HD 1080p resolution</li>
          <li>Short-throw ratio (0.69–0.83:1) keeps projector behind the golfer</li>
          <li>Ultra-low 16.7ms input lag for fast feedback</li>
          <li>3,000 lumens for bright, clear visuals</li>
          <li>Auto keystone correction and built-in speaker</li>
        </ul>
        <p>Best for golfers seeking crisp visuals on a budget and easy plug-and-play setup.</p>
      `
    },

    "BenQ AH30ST": {
      title: "BenQ AH30ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-AH30ST-3000-Lumen-Golf-Simulator-Projector-front-view_2048x_7e43d8b5-92e8-4d5c-b3f5-b3682130a63b.webp?v=1757893842",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-AH30ST-3000-Lumen-Golf-Simulator-Projector-ceiling-mounted-black-projector-with-metal-arm_2000x_8a0e24f9-bf04-4d3d-a552-c8bf910d866b.webp?v=1757893842",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-AH30ST-3000-Lumen-Golf-Simulator-Projector-top-view_2000x_6a4a4379-6df7-47a6-af85-70eb446cb0f8.webp?v=1757893842",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-AH30ST-3000-Lumen-Golf-Simulator-Projector-angled-view-with-dimensions-in-inch-and-mm_2000x_c5bf56c2-c25d-4d54-bc71-e62e0d5acaa7.webp?v=1757893842"
      ],
      html: `
        <h3>BenQ AH30ST – Auto Screen Fill Made Easy</h3>
        <p>The <strong>AH30ST</strong> is a short throw projector designed with golf simulators in mind. Featuring Auto Screen Fill technology, it automatically adjusts the image to perfectly match your screen dimensions, saving setup time and hassle. With Full HD resolution and strong brightness, it’s an affordable step below the AH700ST while still delivering excellent visuals.</p>
        <ul class="list-disc list-inside">
          <li>1080p Full HD resolution for sharp, detailed images</li>
          <li>3,300 lumens brightness – clear picture in controlled lighting</li>
          <li>Auto Screen Fill technology for instant screen alignment</li>
          <li>Short throw ratio – large image from close placement</li>
          <li>Low input lag and smooth performance for simulation and gaming</li>
        </ul>
        <p>Includes AH30ST projector, remote control, power cable, and user manual – ready for a fast and frustration-free setup.</p>
      `
    },

    "BenQ AH700ST": {
      title: "BenQ AH700ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-AH700ST-Golf-Simulator-Projector-BenQ-21097469.png?v=1733962397"
      ],
      html: `
        <h3>BenQ AH700ST – Crisp Color in Any Light</h3>
        <p>The <strong>AH700ST</strong> is a premium 1080p laser projector optimized for golf simulators. With 4,000 lumens and Golf Mode color tuning, it’s built for performance in ambient lighting.</p>
        <ul class="list-disc list-inside">
          <li>1080p laser projection with 4,000 lumens</li>
          <li>Golf Mode for true-to-life greens and course textures</li>
          <li>Short-throw (0.69–0.83:1) for safe, behind-golfer placement</li>
          <li>Auto screen fit + keystone for easy setup</li>
          <li>Up to 30,000-hour laser lifespan</li>
        </ul>
        <p>Ideal for users who want stunning visuals, quiet operation, and set-it-and-forget-it longevity.</p>
      `
    },

    "Optoma UHZ35ST": {
      title: "Optoma UHZ35ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-UHZ35ST-Front.jpg?v=1739841522",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-UHZ35ST-Golf-Simulator-Projector-Front-Golf-Sim-Depot-Front-2.jpg?v=1741532239",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-UHZ35ST-Golf-Simulator-Projector-Front-Golf-Sim-Depot-Angle.jpg?v=1741532239",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-UHZ35ST-Golf-Simulator-Projector-Front-Golf-Sim-Depot-Top.jpg?v=1741532239",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-UHZ35ST-Golf-Simulator-Projector-Front-Golf-Sim-Depot-Back.jpg?v=1741532239"
      ],
      html: `
        <h3>Optoma UHZ35ST – 4K Brilliance with Pro Features</h3>
        <p>The <strong>UHZ35ST</strong> combines 4K clarity, a 0.50:1 short-throw ratio, and ultra-low latency for serious golf simulator performance.</p>
        <ul class="list-disc list-inside">
          <li>True 4K UHD with HDR10 & HLG support</li>
          <li>3,500 lumens brightness for vivid daylight visibility</li>
          <li>Laser light source with 30,000-hour lifespan</li>
          <li>Advanced image tools: lens shift, 4-corner correction, and Golf Sim Mode</li>
          <li>Ultra-responsive for real-time sim feedback</li>
        </ul>
        <p>A great choice for players wanting pro-grade visuals and rock-solid setup flexibility.</p>
      `
    },

    "BenQ AK700ST": {
      title: "BenQ AK700ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ak700st-gallery3.webp?v=1740349888",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ak700st-gallery2.webp?v=1740349888",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/ak700st-gallery4.webp?v=1740349876"
      ],
      html: `
        <h3>BenQ AK700ST – Short-Throw 4K Powerhouse</h3>
        <p>The <strong>AK700ST</strong> delivers razor-sharp 4K, high brightness, and Golf Mode tuning in a safe short-throw format. Ideal for golf sim enclosures and pro-level builds.</p>
        <ul class="list-disc list-inside">
          <li>True 4K UHD with 4,000 lumens</li>
          <li>HDR10 & HLG support for enhanced realism</li>
          <li>Golf Mode for lifelike color accuracy</li>
          <li>Short-throw (0.69–0.83:1) keeps projector behind you</li>
          <li>Flexible ports, including HDMI 2.0 and USB-C</li>
        </ul>
        <p>One of the best all-around 4K projectors for players needing clarity, brightness, and precision tuning.</p>
      `
    },

    "BenQ LK936ST": {
      title: "BenQ LK936ST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-LK936ST-Golf-Simulator-Projector-BenQ-20991655.png?v=1733959235",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-LK936ST-Golf-Simulator-Projector-BenQ-20991543.png?v=1733959238",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-LK936ST-Golf-Simulator-Projector-BenQ-20991783.webp?v=1733959240",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-LK936ST-Golf-Simulator-Projector-BenQ-20991967.webp?v=1733959231",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/BenQ-LK936ST-Golf-Simulator-Projector-BenQ-20991832.webp?v=1733959228"
      ],
      html: `
        <h3>BenQ LK936ST – Brightest 4K Laser in the Game</h3>
        <p>The <strong>LK936ST</strong> is BenQ’s top-tier 4K short-throw projector, delivering stunning brightness and detail in any lighting. With Golf Mode and precise correction tools, it's built for high-end simulator studios.</p>
        <ul class="list-disc list-inside">
          <li>4K UHD resolution with HDR10 & HLG support</li>
          <li>Massive 5,100 lumens brightness for daylight clarity</li>
          <li>Short-throw (0.81–0.89) fits most sim enclosures</li>
          <li>Golf Mode + vertical lens shift, corner fit, and auto keystone</li>
          <li>Whisper-quiet operation at 32dB (Eco Mode)</li>
        </ul>
        <p>A go-to for golf enthusiasts who want maximum brightness and professional-grade image control.</p>
      `
    },

    "Optoma ZK608TST": {
      title: "Optoma ZK608TST",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-ZU607TST-Golf-Sim-Depot-Front2.jpg?v=1741531194",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-ZU607TST-Golf-Sim-Depot-Front.jpg?v=1741531194",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-ZU607TST-Golf-Sim-Depot-Angle.jpg?v=1741531194",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-ZU607TST-Golf-Sim-Depot-Angle-Left.jpg?v=1741531194",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Optoma-ZU607TST-Golf-Sim-Depot-Top.jpg?v=1741531194"
      ],
      html: `
        <h3>Optoma ZK608TST – 4K Laser with Power and Precision</h3>
        <p>The <strong>ZK608TST</strong> combines ultra-bright 4K resolution with a 0.58:1 short-throw ratio—making it perfect for golf simulator setups in bright rooms or larger spaces.</p>
        <ul class="list-disc list-inside">
          <li>True 4K UHD with 6,000 lumens brightness</li>
          <li>Short-throw 0.58:1 for big screens in tight spaces</li>
          <li>Golf Sim Picture Mode + HDR10/HLG support</li>
          <li>Vertical lens shift, 4-corner correction, and auto keystone</li>
          <li>30,000-hour laser for long-term reliability</li>
        </ul>
        <p>For golfers who want the brightest, sharpest visuals with flexible mounting and pro-calibrated picture presets.</p>
      `
    }
  },

  mat: {
    "ProStrike 5'x5' Hitting Mat": {
      title: "ProStrike 5'x5' Hitting Mat",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/PROSTRIKE_MAT_540x-Golf-Sim-Depot.webp?v=1742554797",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Prostrike_4_540x-Golf-Sim-Depot.webp?v=1742554797",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/prostrike_shopify_2_540x-Golf-Sim-Depot.webp?v=1742554797",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Prostrike_3_540x-Golf-Sim-Depot.webp?v=1742554797",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/prostrike3_8efd1c09-b168-464a-889f-082db7f22a19_540x-Golf-Sim-Depot.webp?v=1742554797"
      ],
      html: `
        <h3>ProStrike Commercial Golf Mat – Authentic Feel & Durability</h3>
        <p>Built for serious practice, the <strong>ProStrike Commercial Golf Mat</strong> delivers real tee compatibility, soft impact turf, and stable, durable construction. Ideal for indoor and outdoor use.</p>
        <ul class="list-disc list-inside">
          <li>Real tee compatibility</li>
          <li>Soft, wrist-friendly 1" turf pile</li>
          <li>Stable urethane backing</li>
          <li>30% denser turf for extended durability</li>
          <li>Includes rubber tees, alignment sticks, and ball tray</li>
        </ul>
        <p>Measures 5' x 5'. 37 lbs. Designed for premium indoor/outdoor setups.</p>
      `
    },

    "Carl's 4'x5' HotShot Hitting Mat": {
      title: "Carl's 4'x5' HotShot Hitting Mat",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/HotShot-4x5.png?v=1745751721",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/hotshot-mats-stacked-flat-dims-logo.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Carls-HotShot-HittingStrips.png?v=1739719645",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_8.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_6.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_2.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_1.webp?v=1739745505"
      ],
      html: `
        <h3>Carl’s HotShot Golf Mat – Comfort, Durability, and Customization</h3>
        <p>The <strong>HotShot Golf Mat</strong> is built for golfers who want durable, joint-friendly turf with a customizable hitting area. Requires a <strong>separate hitting insert</strong> (sold separately).</p>
        <ul class="list-disc list-inside">
          <li>High-end fiber construction for realistic feel</li>
          <li>Anti-fatigue design for longer practice sessions</li>
          <li>Offset hitting area – ideal for right- or left-handed golfers</li>
          <li>Compatible with HotShot Standard, Foam, and Gel inserts</li>
        </ul>
        <p>Size: 4' x 5'.</p>
      `
    },

    "Carl's 5'x8' HotShot Hitting Mat": {
      title: "Carl's 5'x8' HotShot Hitting Mat",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/HotShot-5x8.png?v=1745751721",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/hotshot-mats-stacked-flat-dims-logo.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Carls-HotShot-HittingStrips.png?v=1739719645",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_8.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_6.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_2.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_1.webp?v=1739745505"
      ],
      html: `
        <h3>Carl’s HotShot Golf Mat – Comfort, Durability, and Customization</h3>
        <p>The <strong>HotShot Golf Mat</strong> is built for golfers who want durable, joint-friendly turf with a customizable hitting area. Requires a <strong>separate hitting insert</strong> (sold separately).</p>
        <ul class="list-disc list-inside">
          <li>High-end fiber construction for realistic feel</li>
          <li>Anti-fatigue design for longer practice sessions</li>
          <li>Centered hitting area for balanced setups</li>
          <li>Compatible with HotShot Standard, Foam, and Gel inserts</li>
        </ul>
        <p>Size: 5' x 8'.</p>
      `
    },

    "Carl's 4'x9' HotShot Hitting Mat": {
      title: "Carl's 4'x9' HotShot Hitting Mat",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/HotShot-4x9.png?v=1745751721",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/hotshot-mats-stacked-flat-dims-logo.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Carls-HotShot-HittingStrips.png?v=1739719645",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_8.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_6.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_2.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_1.webp?v=1739745505"
      ],
      html: `
        <h3>Carl’s HotShot Golf Mat – Comfort, Durability, and Customization</h3>
        <p>The <strong>HotShot Golf Mat</strong> is built for golfers who want durable, joint-friendly turf with a customizable hitting area. Requires a <strong>separate hitting insert</strong> (sold separately).</p>
        <ul class="list-disc list-inside">
          <li>High-end fiber construction for realistic feel</li>
          <li>Anti-fatigue design for longer practice sessions</li>
          <li>Centered hitting area for balanced setups</li>
          <li>Compatible with HotShot Standard, Foam, and Gel inserts</li>
        </ul>
        <p>Size: 4' x 9'.</p>
      `
    },

    "Carl's 6'x10' HotShot Hitting Mat": {
      title: "Carl's 6'x10' HotShot Hitting Mat",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/HotShot-6x10.png?v=1745751721",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/hotshot-mats-stacked-flat-dims-logo.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Carls-HotShot-HittingStrips.png?v=1739719645",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_8.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_6.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_2.webp?v=1739745505",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/carls-hotshot-golf-mat_1.webp?v=1739745505"
      ],
      html: `
        <h3>Carl’s HotShot Golf Mat – Comfort, Durability, and Customization</h3>
        <p>The <strong>HotShot Golf Mat</strong> is built for golfers who want durable, joint-friendly turf with a customizable hitting area. Requires a <strong>separate hitting insert</strong> (sold separately).</p>
        <ul class="list-disc list-inside">
          <li>High-end fiber construction for realistic feel</li>
          <li>Anti-fatigue design for longer practice sessions</li>
          <li>Centered hitting area for balanced setups</li>
          <li>Compatible with HotShot Standard, Foam, and Gel inserts</li>
        </ul>
        <p>Size: 6' x 10'.</p>
      `
    },

    "SIGPRO Softy LITE (4'x5')": {
      title: "SIGPRO Softy LITE (4'x5')",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/4x5-LITE-angled-GolfSimDepot.jpg?v=1741436684",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Softy-lite-mat-GolfSimDepot.jpg?v=1741438955",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-thickness-zoomed-Golf-Sim-Depot.webp?v=1741741136",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-under-Golf-Sim-Depot.jpg?v=1741741136"
      ],
      html: `
        <h3>SIGPRO Softy Lite 4'x5' Golf Mat – Compact, Comfortable, and Built to Last</h3>
        <p>The <strong>SIGPRO Softy Lite 4'x5'</strong> delivers realistic feedback in a compact, durable design. Perfect for small simulator spaces or indoor practice setups.</p>
        <ul class="list-disc list-inside">
          <li>Space-saving 4' x 5' size</li>
          <li>Replaceable hitting strip extends mat life</li>
          <li>Shock-absorbing for wrist and joint protection</li>
          <li>Indoor-optimized design</li>
          <li>Note: Does not accept real tees</li>
        </ul>
        <p>Ideal for irons, wedges, and hybrids in compact golf simulator setups.</p>
      `
    },

    "SIGPRO Softy LITE (4'x7')": {
      title: "SIGPRO Softy LITE (4'x7')",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/4x7-lite-angled-_Golf_Sim_Depot.jpg?v=1741438485",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Softy-lite-mat-GolfSimDepot.jpg?v=1741438955",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-thickness-zoomed-Golf-Sim-Depot.webp?v=1741741136",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-under-Golf-Sim-Depot.jpg?v=1741741136"
      ],
      html: `
        <h3>SIGPRO Softy Lite 4'x7' Golf Mat – Durable, Comfortable, and Simulator-Ready</h3>
        <p>The <strong>SIGPRO Softy Lite 4'x7'</strong> adds more stance room without sacrificing the forgiving feel you need for indoor training.</p>
        <ul class="list-disc list-inside">
          <li>Expanded 4' x 7' stance area</li>
          <li>Replaceable hitting strip for long-term durability</li>
          <li>Shock-absorbing design minimizes joint stress</li>
          <li>Compatible with floor-mounted launch monitors</li>
          <li>Note: Does not accept real tees</li>
        </ul>
        <p>Perfect for golfers needing a wider practice area in simulators or training studios.</p>
      `
    },

    "SIGPRO Softy LITE (4'x10')": {
      title: "SIGPRO Softy LITE (4'x10')",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/4x10-lite-angled-_Golf_Sim_Depot.jpg?v=1741438955",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/Softy-lite-mat-GolfSimDepot.jpg?v=1741438955",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-thickness-zoomed-Golf-Sim-Depot.webp?v=1741741136",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/softy-lite-under-Golf-Sim-Depot.jpg?v=1741741136"
      ],
      html: `
        <h3>SIGPRO Softy Lite 4'x10' Golf Mat – Spacious, Durable, and Dual-Stance Friendly</h3>
        <p>The <strong>SIGPRO Softy Lite 4'x10'</strong> offers a generous surface for both right- and left-handed golfers, with a replaceable hitting strip for endless practice sessions.</p>
        <ul class="list-disc list-inside">
          <li>Large 4' x 10' hitting area</li>
          <li>Dual-stance design (left- and right-handed golfers)</li>
          <li>Shock-absorbing surface for extended comfort</li>
          <li>Replaceable hitting strip for long-term value</li>
          <li>Note: Does not accept real tees</li>
        </ul>
        <p>Ideal for serious golfers building a full-size simulator studio at home.</p>
      `
    },

    "SIGPRO Softy (4'x7')": {
      title: "SIGPRO Softy (4'x7')",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21033158.webp?v=1733960466",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21032881.webp?v=1733960453",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21033050.webp?v=1733960451",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21032993.webp?v=1733960458"
      ],
      html: `
        <h3>SIGPRO Softy 4'x7' Golf Mat – Premium Feel, Real Tee Compatibility</h3>
        <p>The <strong>SIGPRO Softy 4'x7'</strong> delivers elite-level feel with a replaceable hitting strip and real tee compatibility, built from direct player feedback.</p>
        <ul class="list-disc list-inside">
          <li>Soft foam core with lush Teeline turf</li>
          <li>Real tee acceptance for authentic practice</li>
          <li>Replaceable hitting strip for maximum durability</li>
          <li>Shock absorption for safer, longer sessions</li>
          <li>Hand-built in the USA</li>
        </ul>
        <p>Perfect for serious golfers who want true realism and all-day practice comfort.</p>
      `
    },

    "SIGPRO Softy (4'x10')": {
      title: "SIGPRO Softy (4'x10')",
      images: [
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x10_-Hitting-Mat-The-Indoor-Golf-Shop-21036746.webp?v=1733960563",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x10_-Hitting-Mat-The-Indoor-Golf-Shop-21036833.webp?v=1733960560",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21033050.webp?v=1733960451",
        "https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SIGPRO-Softy-4_x7_-Hitting-Mat-The-Indoor-Golf-Shop-21032993.webp?v=1733960458"
      ],
      html: `
        <h3>SIGPRO Softy 4'x10' Golf Mat – Maximum Surface, Maximum Comfort</h3>
        <p>The <strong>SIGPRO Softy 4'x10'</strong> offers a spacious surface for both right- and left-handed players with true fairway-like feel and real tee capability.</p>
        <ul class="list-disc list-inside">
          <li>Large 4' x 10' footprint</li>
          <li>Real tee compatibility</li>
          <li>Replaceable hitting strip extends mat life</li>
          <li>Soft, forgiving foam and turf for joint protection</li>
          <li>Made in the USA</li>
        </ul>
        <p>Built for players who demand the best simulator mat experience at home or professionally.</p>
      `
    }
  }
};

window.WALLS = window.WALLS || {
  // Summary line under the "Curtains" title.
  curtainSummary() {
    try {
      const h = (window.curtainUI && curtainUI.height) || null;
      const d = (window.curtainUI && curtainUI.depth) || null;
      const q = typeof getQty === 'function' ? (getQty('curtain', h, d) || 0) : 0;
      if (!h || !d || !q) return '';
      return `${h}″H × ${d}″D • ${q} panel${q > 1 ? 's' : ''}`;
    } catch { return ''; }
  },

  // Per-card subtotal in cents for curtains + linked add-ons (qty-aware).
  curtainsSubtotalCents() {
    try {
      const extras = (window.selectedFinishing && selectedFinishing.wallExtras) || [];
      return extras.reduce((t, it) => {
        const kind = (it.kind || '').toLowerCase();
        if (!['curtain', 'hardware', 'valence'].includes(kind)) return t;
        const cents = typeof priceToCents === 'function' ? priceToCents(it) : (it.price_cents || 0);
        const qty = Number(it.qty || 1);
        return t + cents * (Number.isFinite(qty) && qty > 0 ? qty : 1);
      }, 0);
    } catch { return 0; }
  },

  // Stubs for future Wall Panels
  panelSummary() {
    const ui = window.panelsUI || null;
    if (!ui || !ui.size || !ui.qty) return '';
    return `${ui.size} • ${ui.qty} pcs`;
  },
  panelsSubtotalCents() {
    const extras = (window.selectedFinishing && selectedFinishing.wallExtras) || [];
    return extras.reduce((t, it) => {
      if ((it.kind || '').toLowerCase() !== 'panel') return t;
      const cents = typeof priceToCents === 'function' ? priceToCents(it) : (it.price_cents || 0);
      const qty = Number(it.qty || 1);
      return t + cents * (Number.isFinite(qty) && qty > 0 ? qty : 1);
    }, 0);
  }
};

// === COMPUTERS (static; no hydration) ===
window.BUILDER = window.BUILDER || {};
window.BUILDER.catalog = window.BUILDER.catalog || {};

window.BUILDER.catalog.computers = [
  // TIP: fill priceCents with your current selling price × 100
  // variantId is optional; add it if you want to add to cart without a lookup later
  { key: 'SurfThing M3H Golf Simulator Laptop',                         handle: 'surfthing-m3h-golf-simulator-laptop',                     priceCents: 289900,        variantId: null },
  { key: 'SurfThing SG3-5802 Golf Simulator & Gaming Computer',         handle: 'surfthing-sg3-5802-golf-simulator-gaming-pc',   priceCents: 394900,        variantId: null },
  { key: 'SurfThing SG3-5702Ti Golf Simulator & Gaming Computer',       handle: 'surfthing-sg3-5702ti-golf-simulator-gaming-pc', priceCents: 304900,        variantId: null },
  { key: 'SurfThing SG3-5702 Golf Simulator & Gaming Computer',         handle: 'surfthing-sg3-5702-golf-simulator-gaming-pc',   priceCents: 274900,        variantId: null },
  { key: 'SurfThing SG3-5602 Golf Simulator & Gaming Computer',         handle: 'surfthing-sg3-5602-golf-simulator-gaming-pc',   priceCents: 199900,        variantId: null }
];

// (you already added modalContent.computer earlier; keep that as-is)


// === Uni-modal copy ===
window.BUILDER.modalContent = window.BUILDER.modalContent || {};
window.BUILDER.modalContent.computer = Object.assign(
  {},
  window.BUILDER.modalContent.computer || {},
  {
    // Laptop
    'SurfThing M3H Golf Simulator Laptop': {
      title: 'SurfThing M3H Golf Simulator Laptop',
      images: [
        // Replace this URL if you have a better laptop product image
        'https://cdn.shopify.com/s/files/1/0685/9721/9555/files/1....024x1024_dcce5594-8c42-4e72-901a-1640de418f80.webp?v=1758454030'
      ],
      html: `
        <h3>What you can expect</h3>
        <p>Powerful, portable golf-sim laptop. Great for 1440p projectors and dual-display setups (projector + monitor). 4K output is achievable with moderate settings.</p>
        <ul class="list-disc list-inside">
          <li><strong>Runs your sim software:</strong> GSPro, E6 CONNECT, TGC 2019, Creative Golf.</li>
          <li><strong>Works with PC-based launch monitors:</strong> Uneekor EYE series, ProTee VX, SkyTrak+ (with plan) via their Windows apps or sim plugins.</li>
          <li><strong>Projectors:</strong> HDMI/DisplayPort for easy hookup; recommended at 1440p or 1080p high-FPS. 4K possible with balanced settings.</li>
        </ul>
        <p class="text-xs text-gray-500">Key components: Intel Core Ultra 9; NVIDIA GeForce RTX 5070 Laptop; Windows 11.</p>
      `
    },

    // Desktops
    'SurfThing SG3-5802 Golf Simulator & Gaming Computer': {
      title: 'SurfThing SG3-5802 Golf Simulator & Gaming Computer',
      images: ['https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SG3-5802.webp?v=1756586538'],
      html: `
        <h3>What you can expect</h3>
        <p><strong>Best choice for 4K</strong> and heavy sim + streaming. Tons of headroom for high-detail courses and multi-app workflows.</p>
        <ul class="list-disc list-inside">
          <li><strong>Runs your sim software:</strong> GSPro, E6 CONNECT, TGC 2019—effortlessly.</li>
          <li><strong>Launch monitors:</strong> PC-based systems via Windows apps/plugins (Uneekor EYE series, ProTee VX, SkyTrak+).</li>
          <li><strong>Projectors:</strong> Confident 4K at 60fps+ (AK700ST, LK936ST, ZK608TST, UHZ35ST). 1440p/1080p at very high FPS.</li>
          <li><strong>Ports:</strong> HDMI/DisplayPort for projector + TV/monitor dual display.</li>
        </ul>
        <p class="text-xs text-gray-500">Key components: Intel Core Ultra 7; NVIDIA RTX 5080; Windows 11.</p>
      `
    },

    'SurfThing SG3-5702Ti Golf Simulator & Gaming Computer': {
      title: 'SurfThing SG3-5702Ti Golf Simulator & Gaming Computer',
      images: ['https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SG3-5602.webp?v=1756583852'],
      html: `
        <h3>What you can expect</h3>
        <p><strong>Top-tier 4K option</strong>. Excellent 4K play at 60fps in most titles; absolutely flies at 1440p/1080p.</p>
        <ul class="list-disc list-inside">
          <li><strong>Software:</strong> GSPro, E6 CONNECT, TGC 2019—no sweat.</li>
          <li><strong>Launch monitors:</strong> Works with Windows-compatible systems (Uneekor EYE series, ProTee VX, SkyTrak+).</li>
          <li><strong>Projectors:</strong> 4K at 60fps is the sweet spot; 1440p/1080p for ultra-high refresh.</li>
          <li><strong>Ports:</strong> HDMI/DP for projector + secondary display.</li>
        </ul>
        <p class="text-xs text-gray-500">Key components: Intel Core Ultra 5; NVIDIA RTX 5070 Ti; Windows 11.</p>
      `
    },

    'SurfThing SG3-5702 Golf Simulator & Gaming Computer': {
      title: 'SurfThing SG3-5702 Golf Simulator & Gaming Computer',
      images: ['https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SG3-5602.webp?v=1756583852'],
      html: `
        <h3>What you can expect</h3>
        <p><strong>4K-ready</strong> in most sim titles with balanced settings; outstanding at 1440p/1080p.</p>
        <ul class="list-disc list-inside">
          <li><strong>Software:</strong> GSPro, E6 CONNECT, TGC 2019.</li>
          <li><strong>Launch monitors:</strong> Windows-compatible devices via their apps/plugins (Uneekor, ProTee VX, SkyTrak+).</li>
          <li><strong>Projectors:</strong> Great 4K @60; screaming at 1440p/1080p.</li>
          <li><strong>Ports:</strong> HDMI/DP for projector and a second screen.</li>
        </ul>
        <p class="text-xs text-gray-500">Key components: Intel Core Ultra 5; NVIDIA RTX 5070; Windows 11.</p>
      `
    },

    'SurfThing SG3-5602 Golf Simulator & Gaming Computer': {
      title: 'SurfThing SG3-5602 Golf Simulator & Gaming Computer',
      images: ['https://cdn.shopify.com/s/files/1/0685/9721/9555/files/SG3-5602.webp?v=1756583852'],
      html: `
        <h3>What you can expect</h3>
        <p><strong>Great value</strong> for 1080p or 1440p simulators. 4K is possible for menus/casual play with reduced settings.</p>
        <ul class="list-disc list-inside">
          <li><strong>Software:</strong> GSPro, E6 CONNECT, TGC 2019—runs smoothly at 1080p/1440p.</li>
          <li><strong>Launch monitors:</strong> Windows-compatible devices via their apps/plugins (Uneekor, ProTee VX, SkyTrak+).</li>
          <li><strong>Projectors:</strong> Best match is 1080p/1440p; 4K usable with settings tweaks.</li>
          <li><strong>Ports:</strong> HDMI/DP for easy projector hookup; dual-display ready.</li>
        </ul>
        <p class="text-xs text-gray-500">Key components: Intel Core Ultra 5; NVIDIA RTX 5060; Windows 11.</p>
      `
    }
  }
);

// === WALL TILES (static; qty-aware in wallExtras) ===
window.BUILDER = window.BUILDER || {};
window.BUILDER.catalog = window.BUILDER.catalog || {};

window.BUILDER.catalog.wallTiles = [
  { key: 'Golf Room Carpet Tiles (Thin)',      handle: 'golf-room-carpet-tiles',     priceCents: 14995, coverageSqFt: 100, packQty: 25, thickness: '4mm', image: 'https://cdn.shopify.com/s/files/1/0685/9721/9555/files/golf-room-carpet-wall-tiles_5.webp?v=1759278001' },
  { key: 'Acoustic Golf Room Tiles (Thicker)', handle: 'acoustic-golf-room-tiles',   priceCents: 27995, coverageSqFt: 100, packQty: 25, thickness: '9mm', image: 'https://cdn.shopify.com/s/files/1/0685/9721/9555/files/acoustic-golf-room-wall-tiles_4.webp?v=1759278001' }
];

// === Uni-modal copy for Wall Tiles ===
window.BUILDER.modalContent = window.BUILDER.modalContent || {};
window.BUILDER.modalContent.walls = Object.assign(
  {},
  window.BUILDER.modalContent.walls || {},
  {
    'Golf Room Carpet Tiles (Thin)': {
      title: 'Golf Room Carpet Tiles',
      images: [], // add image URLs if you have them
      html: `
        <h3>What are they?</h3>
        <p>Low-pile, adhesive-backed black carpet tiles that soften the look of your room, cut glare, and add light sound absorption.</p>
        <ul class="list-disc list-inside">
          <li><strong>Protection:</strong> Some wall/ceiling protection; for max protection, consider Built-In Padded Panels.</li>
          <li><strong>Where they stick:</strong> Plywood, drywall, painted drywall (adhesive can lift paint—measure/mark before applying).</li>
          <li><strong>Customize:</strong> Cut to fit corners, soffits, lights, etc.</li>
        </ul>
        <h4 class="mt-3 font-semibold">Specs</h4>
        <ul class="list-disc list-inside">
          <li>Size: 24" × 24"</li>
          <li>Thickness: 4mm</li>
          <li>Pack: 25 tiles &nbsp;•&nbsp; Coverage: ~100 sq ft</li>
        </ul>
      `
    },
    'Acoustic Golf Room Tiles (Thicker)': {
      title: 'Acoustic Golf Room Tiles',
      images: [],
      html: `
        <h3>What are they?</h3>
        <p>Smooth black acoustic tiles for better sound absorption and ambient light control. Lighter/easier than heavy padded panels.</p>
        <ul class="list-disc list-inside">
          <li><strong>Protection:</strong> Some wall/ceiling protection; for max protection use Built-In Padded Panels.</li>
          <li><strong>Where they stick:</strong> Plywood, drywall, painted drywall (adhesive can lift paint—measure/mark first).</li>
          <li><strong>Customize:</strong> Cut to fit architectural features for a clean look.</li>
        </ul>
        <h4 class="mt-3 font-semibold">Specs</h4>
        <ul class="list-disc list-inside">
          <li>Size: 24" × 24"</li>
          <li>Thickness: 9mm</li>
          <li>Pack: 25 tiles &nbsp;•&nbsp; Coverage: ~100 sq ft</li>
        </ul>
      `
    }
  }
);

// === Walls helpers (card summary + subtotal) ===
window.WALLS = window.WALLS || {};
Object.assign(window.WALLS, {
  tilesSummary(){
    try {
      const extras = (window.selectedFinishing?.wallExtras || []);
      const line = extras.find(it => ['carpet-tiles','acoustic-tiles'].includes((it.kind||'').toLowerCase()));
      if (!line) return '';
      const packs = Number(line.qty || 0);
      if (!packs) return '';
      const coverage = (line.coverageSqFt || 100) * packs;
      const label = line.kind === 'acoustic-tiles' ? 'Acoustic Tiles' : 'Carpet Tiles';
      return `${label} • ${packs} pack${packs>1?'s':''} • ~${coverage} sq ft`;
    } catch { return ''; }
  },
  tilesSubtotalCents(){
    try {
      const extras = (window.selectedFinishing?.wallExtras || []);
      return extras.reduce((t, it) => {
        const kind = (it.kind||'').toLowerCase();
        if (!['carpet-tiles','acoustic-tiles'].includes(kind)) return t;
        const cents = typeof window.priceToCents === 'function' ? priceToCents(it) : Number(it.price_cents||it.priceCents||0);
        const qty   = Number(it.qty || 1);
        return t + (Number.isFinite(qty) && qty>0 ? qty : 1) * cents;
      }, 0);
    } catch { return 0; }
  }
});



